import { c as _c } from "react/compiler-runtime";
import { getOrgEntityStatusesOptions } from '@onefootprint/fetch-dashboard';
import { IcoChevronDown16 } from '@onefootprint/icons';
import type { Entity, EntityOrgStatus, VaultKind } from '@onefootprint/request-types/dashboard';
import { Button, Dialog, Popover } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import CustomStatusSelectors from '@/components/custom-status-selectors';
const useCustomStatuses = entityKind => {
  const $ = _c(7);
  let t0;
  if ($[0] !== entityKind) {
    t0 = getOrgEntityStatusesOptions({
      query: {
        entityType: entityKind
      }
    });
    $[0] = entityKind;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!entityKind;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: t3
  } = useQuery(t2);
  let t4;
  if ($[5] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const data = t4;
  return data;
};
type StatusSelectorsProps = {
  entity: Entity;
  customStatuses: EntityOrgStatus[];
};
const StatusSelectors = t0 => {
  const $ = _c(4);
  const {
    entity,
    customStatuses
  } = t0;
  let t1;
  if ($[0] !== customStatuses || $[1] !== entity.id || $[2] !== entity.statuses) {
    t1 = <CustomStatusSelectors customStatuses={customStatuses} assignedStatuses={entity.statuses} entityId={entity.id} direction="column" skipConfirmOnChange={true} />;
    $[0] = customStatuses;
    $[1] = entity.id;
    $[2] = entity.statuses;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const StatusesPopover = t0 => {
  const $ = _c(11);
  const {
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "header"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("investigations", t1);
  const customStatuses = useCustomStatuses(entity.kind);
  if (customStatuses.length === 0) {
    return null;
  }
  let t2;
  if ($[1] !== customStatuses || $[2] !== entity) {
    t2 = <div className="p-3 max-w-[90vw] max-h-[60vh] overflow-y-auto"><StatusSelectors entity={entity} customStatuses={customStatuses} /></div>;
    $[1] = customStatuses;
    $[2] = entity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Button variant="secondary" size="compact" suffixIcon={IcoChevronDown16}>{t3}</Button>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <Popover side="bottom" align="end" content={t2}>{t4}</Popover>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};

// Phones open the statuses from the header's `…` menu, which has no trigger to anchor a popover to.
const StatusesDialog = t0 => {
  const $ = _c(14);
  let onClose;
  let open;
  let props;
  if ($[0] !== t0) {
    ({
      open,
      onClose,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onClose;
    $[2] = open;
    $[3] = props;
  } else {
    onClose = $[1];
    open = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "header"
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    t
  } = useTranslation("investigations", t1);
  let t2;
  if ($[5] !== t) {
    t2 = t(_temp2);
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props) {
    t3 = <StatusSelectors {...props} />;
    $[7] = props;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== onClose || $[10] !== open || $[11] !== t2 || $[12] !== t3) {
    t4 = <Dialog title={t2} open={open} onClose={onClose} size="compact">{t3}</Dialog>;
    $[9] = onClose;
    $[10] = open;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export { StatusesDialog, StatusesPopover, useCustomStatuses };
export default StatusesPopover;
function _temp($) {
  return $.statuses;
}
function _temp2($) {
  return $.statuses;
}